import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const styles = StyleSheet.create({
  row: {
    flexDirection: 'row',
    backgroundColor: '#f6fffa',
    borderBottomWidth: 1,
    borderBottomColor: '#4CAF50',
  },
  cell: {
    padding: 5,
    fontSize: 8,
    fontWeight: 'bold',
    textAlign: 'center',
    borderRightWidth: 1,
    borderRightColor: '#4CAF50',
  },
  lastCell: {
    borderRightWidth: 0,
  },
  emphasizedHeaderCell: {
    backgroundColor: '#c8e6c9',
  },
  moreEmphasizedHeaderCell: {
    backgroundColor: '#a5d6a7',
  },
});

const SkuTableHeadRow = () => (
  <View style={styles.row}>
    <Text style={[styles.cell, { width: 80 }]}>Art</Text>
    <Text style={[styles.cell, { width: 100 }]}>Supplier Description</Text>
    <Text style={[styles.cell, { width: 56 }]}>r.Turn SKU</Text>
    <Text style={[styles.cell, styles.emphasizedHeaderCell, { width: 44 }]}>
      Box Qty
    </Text>
    <Text style={[styles.cell, styles.emphasizedHeaderCell, { width: 44 }]}>
      Item per Box
    </Text>
    <Text style={[styles.cell, styles.emphasizedHeaderCell, { width: 48 }]}>
      Total Items
    </Text>
    <Text style={[styles.cell, styles.moreEmphasizedHeaderCell, { width: 52 }]}>
      Cost per Box
    </Text>
    <Text style={[styles.cell, styles.moreEmphasizedHeaderCell, { width: 52 }]}>
      Cost per Item
    </Text>
    <Text style={[styles.cell, styles.moreEmphasizedHeaderCell, { width: 52 }]}>
      Total Cost
    </Text>
  </View>
);

export default SkuTableHeadRow;
